import { Component, Input, OnChanges } from '@angular/core';
import { FormFieldAbstractComponent } from '../abstract.component';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isObservable } from '@shared/core/utils';
import { FormFieldOption } from '@shared/shared/form-fields';

@Component({
  selector: 'crm-form-field-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
})
export class FormFieldRadioButtonComponent extends FormFieldAbstractComponent implements OnChanges {
  @Input() column = false;
  @Input() disabled = false;

  options$: Observable<FormFieldOption[]> = of([]);

  get readonlyValue$(): Observable<any> {
    const value = this.formFieldsService.serializeValues(this.parentFormGroup, [this.field])[this.field.key];

    return this.options$.pipe(
      map(options => {
        const option = options.find(opt => opt.value === value) || { label: '' };
        return option.label;
      }),
    );
  }

  ngOnChanges(): void {
    this.setOptions();
  }

  private setOptions(): void {
    if (!this.field.options) {
      this.options$ = of([]);
      return;
    }

    this.options$ = isObservable(this.field.options) ? this.field.options : of(this.field.options);
  }
}
